import React from "react";
import { Link } from "react-router-dom";

const UnauthorizedPage = () => (
  <section>
    <div id="hms-page-title">
      <h1 className="uk-heading-small">Access Restricted</h1>
    </div>
    <div id="hms-main-body">
      <div className="uk-card uk-card-default uk-card-body uk-text-center uk-padding-large">
        <span uk-icon="icon: lock; ratio: 3" className="uk-text-muted" />
        <p className="uk-margin-top uk-text-lead">
          You don&apos;t have permission to access this page.
        </p>
        <p className="uk-text-muted">
          Contact your account administrator to request access.
        </p>
        <Link
          to="/"
          className="uk-button hms-btn hms-red-btn uk-margin-top"
          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}
        >
          Go to Home
        </Link>
      </div>
    </div>
  </section>
);

export default UnauthorizedPage;
